import { memo } from 'react';
import { Box, Card, CardContent, Chip, Divider, Stack, Typography } from '@mui/material';
import InventoryIcon from '@mui/icons-material/Inventory';
import { SSCCProps } from '../../../datastore/ssccs';

interface Props {
  sscc: SSCCProps;
  duplicateAsnCount: number;
  onClick: () => void;
}

export const UnassignedSsccCard = memo(({ sscc, duplicateAsnCount, onClick }: Props) => (
  <Card
    onClick={onClick}
    sx={{
      border: '1px solid rgba(0,0,0,0.08)',
      borderRadius: 2,
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      transition: 'all 0.2s ease',
      cursor: 'pointer',
      '&:hover': {
        boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
        borderColor: 'rgba(237, 108, 2, 0.3)',
        transform: 'translateY(-2px)'
      }
    }}>
    <CardContent sx={{ p: 2 }}>
      <Stack spacing={1.5}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1.5,
              backgroundColor: 'rgba(237, 108, 2, 0.08)',
              display: 'flex'
            }}>
            <InventoryIcon sx={{ fontSize: 20, color: '#ed6c02' }} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="body2" fontWeight={700} sx={{ color: 'text.primary' }}>
              {sscc.id}
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              {sscc.nickname || 'No nickname'}
            </Typography>
          </Box>
          {duplicateAsnCount > 0 && (
            <Chip
              label={`ASN Dupes: ${duplicateAsnCount}`}
              size="small"
              sx={{
                height: 20,
                fontSize: '0.70rem',
                fontWeight: 600,
                backgroundColor: 'rgba(211, 47, 47, 0.1)',
                color: '#c62828'
              }}
            />
          )}
        </Stack>

        <Divider />

        <Stack spacing={0.5}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
              Status:
            </Typography>
            <Chip
              label={sscc.status || 'Unknown'}
              size="small"
              sx={{
                height: 20,
                fontSize: '0.70rem',
                fontWeight: 600,
                backgroundColor:
                  sscc.status === 'open'
                    ? 'rgba(46, 125, 50, 0.1)'
                    : sscc.status === 'staged'
                      ? 'rgba(25, 118, 210, 0.1)'
                      : 'rgba(158, 158, 158, 0.1)',
                color: sscc.status === 'open' ? '#2e7d32' : sscc.status === 'staged' ? '#1976d2' : '#616161'
              }}
            />
          </Stack>
          {sscc.weight && (
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
                Weight:
              </Typography>
              <Typography variant="caption" sx={{ color: 'text.primary', fontSize: '0.75rem', fontWeight: 600 }}>
                {sscc.weight} kg
              </Typography>
            </Stack>
          )}
        </Stack>
      </Stack>
    </CardContent>
  </Card>
));

UnassignedSsccCard.displayName = 'UnassignedSsccCard';
